import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ArrowLeftIcon = createIcon({
  displayName: 'ArrowLeft',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M5,12h14"></path>
        <path d="M10,7l-5,5"></path>
        <path d="M10,17l-5,-5"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const ArrowLeft: FC<IconProps> = (props) => {
  return <CustomIcon as={ArrowLeftIcon} {...props} />
}

export default memo(ArrowLeft)
